/**
 * Simple context for providing the current user's first name.
 * Decouples ThreadWelcome from auth.
 */

import { createContext, useContext, type ReactNode } from 'react';

const UserNameContext = createContext<string | null>(null);

export function UserNameProvider({ name, children }: { name: string | null; children: ReactNode }) {
  return <UserNameContext.Provider value={name}>{children}</UserNameContext.Provider>;
}

export function useUserName(): string | null {
  return useContext(UserNameContext);
}
